import { inputHandler } from './input';
import { currencyFormater } from './utils';

const onSimpleCalculatorLoad = () => {
  const calculator = document.querySelector('[data-simple-calculator]');

  if (!calculator) return;
  const inputContainer = calculator.querySelector('[data-input-field]');
  const input = inputContainer.querySelector('input');

  inputHandler(inputContainer, (value) => {
    input.value = currencyFormater(value);
  });

};

export default onSimpleCalculatorLoad;
